import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { ToasterService } from './toaster.service';
import { Analytics } from './analytics/analytics.service';
import { EventType } from '../enums/meta.enum';
import { AppConstant } from '../constant/app-constant';
declare let Cashfree: any;

@Injectable({
  providedIn: 'root',
})
export class CashfreeService {
  cashfree: any;
  readonly paymentMode = environment.paymentMode;
  readonly hostUrl = environment.hostUrl;
  readonly baseUrl: string = environment.apiUrl;

  constructor(
    private readonly toaster: ToasterService,
    private readonly http: HttpClient,
    private readonly injector: Injector
  ) {
    this.cashfree = Cashfree({
      mode: this.paymentMode, //or production
    });
  }

  private get analytics(): Analytics {
    return this.injector.get(Analytics);
  }

  cashfreeRedirection(
    sessionId: string,
    paymentUrl: string,
    amount: number,
    page: string
  ): void {
    let checkoutOptions = {
      paymentSessionId: sessionId,
      returnUrl: this.hostUrl + paymentUrl,
    };
    this.analytics.customAnalytics('Redirecting to Payment Gateway', {
      eventType: EventType.log,
      page,
      gateway: AppConstant.PAYMENT_GATEWAY,
    });
    this.cashfree.checkout(checkoutOptions).then((result: any) => {
      this.analytics.customAnalytics('Transaction Capture Success', {
        sessionId,
        amount,
        page,
        eventType: EventType.api,
      });
      if (result.error) {
        this.analytics.failureEvent('Transaction Capture Failure', {
          sessionId,
          amount,
          page,
          error: 'Cashfree Redirection Error',
          reason: result.error?.message ?? 'Unable to get cashfree details',
          eventType: EventType.error,
        });
        this.toaster.error(result.error.message);
      }
    });
  }

  getPaymentDetails(orderId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/wallet/orderDetails/${orderId}`);
  }

  getFilmMakerPaymentDetails(orderId: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/wallet/fmOrderDetails/${orderId}`
    );
  }
}
